export const getLectures = (data) => {
  const payload = data?.result ?? data?.data ?? data;
  if (Array.isArray(payload)) return payload;
  return Array.isArray(payload?.lectures) ? payload.lectures : [];
};

export const getLectureVideo = (value, origin) => {
  try {
    const url = new URL(value);
    if (!["https:", "http:"].includes(url.protocol)) return null;
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    let youtubeId;
    if (host === "youtu.be") youtubeId = url.pathname.split("/")[1];
    if (["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(host)) {
      youtubeId = url.searchParams.get("v") ||
        (/^\/(embed|shorts|live)\//.test(url.pathname) ? url.pathname.split("/")[2] : "");
      if (!youtubeId) return null;
    }
    if (youtubeId) {
      if (!/^[a-zA-Z0-9_-]{11}$/.test(youtubeId)) return null;
      const embed = new URL(`https://www.youtube-nocookie.com/embed/${youtubeId}`);
      embed.searchParams.set("playsinline", "1");
      embed.searchParams.set("controls", "1");
      if (origin && /^https?:\/\//.test(origin)) {
        embed.searchParams.set("origin", new URL(origin).origin);
      }
      return {
        type: "embed",
        url: embed.href,
        watchUrl: `https://www.youtube.com/watch?v=${youtubeId}`,
        thumbnailUrl: `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`,
      };
    }
    if (["vimeo.com", "player.vimeo.com"].includes(host)) {
      const id = url.pathname.match(/\/(\d+)\/?$/)?.[1];
      if (!id) return null;
      const embed = new URL(`https://player.vimeo.com/video/${id}`);
      const hash = url.searchParams.get("h");
      if (hash) embed.searchParams.set("h", hash);
      return { type: "embed", url: embed.href };
    }
    return { type: "video", url: url.href };
  } catch {
    return null;
  }
};
